import { ITipoMinutaAM } from "./TipoMinutaAm";

export class Estrutura {

    id: number;
    nome: string;
    padrao: boolean;
    descricao: string = '';
    tipo: ITipoMinutaAM;
    textoDispositivo: string = '';
    textoVoto: string = '';
    textoEmenta: string = '';
    textoConteudo: string = '';
    textoIdentificacao: string = '';
    textoRelatorio: string = '';
    textoFuncaoMagistrado: string = '';
    selecionada?: boolean;

}
